// extracted by mini-css-extract-plugin
module.exports = {"close-icon":"a10a3f92e9--close-icon--3zkkg"};